'use client';

import type { PropsWithChildren } from 'react';
import type { CriteriaType } from '~/model/CriteriaType';
import type { InteractionType } from '~/model/InteractionType';
import htmlReactParser from 'html-react-parser';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { DataLayer } from '@/app/components/Anayltics/DataLayer';
import { useProgressContext } from '@/app/components/Provider';
import { BeardmanTalking } from '~/components/Beardman/BeardmanTalking/BeardmanTalking';
import { AnalyticEvents, AnalyticValues } from '~/const/appConst';
import { defineDescriptionBasedOnType } from './utils';

export const SorryPage = ({
  children,
  interaction,
  mismatched,
}: PropsWithChildren<{
  interaction: InteractionType;
  mismatched: CriteriaType[];
}>) => {
  const t = useTranslations('PROFILE.COMPLETION.SORRY');
  const { total, setIndex } = useProgressContext();

  const interactionType = t(`INTERACTION_TYPE.${defineDescriptionBasedOnType(interaction?.['@type'])}`);

  useEffect(() => {
    setIndex(total);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [total]);

  return (
    <div data-testid="mismatched-criterias" data-cy="mismatched-criteria">
      <BeardmanTalking
        mood="sad"
        title={t('TITLE')}
        description={(
          <>
            <p>
              {interaction.for_children
                ? t('DESCRIPTION_CHILD', { interactionType })
                : t('DESCRIPTION', { interactionType })}
            </p>
            <ul>
              <p>{htmlReactParser(t('MISMATCHED_CRITERIAS'))}</p>
              {mismatched.map(criterion => (
                <li key={criterion['@id']}>
                  {criterion.label}
                  {' '}
                </li>
              ))}
            </ul>
          </>
        )}
      />
      {children}
      <DataLayer
        value={AnalyticValues.SORRY_PAGE}
        event={AnalyticEvents.CUSTOM_PAGE_VIEW}
      />
    </div>
  );
};
